module.exports = __webpack_public_path__ + "static/img/MA-2103.2d3431d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/listings/custom/MA-2103.jpg
// module id = T/wh
// module chunks = 0